module.exports = __webpack_public_path__ + "static/media/Close.3455babb.svg";